EBContext.modules.QuickAdd = function(options){
	var self = this;
	options = options || {};
	this.options = EBContext.utils.extendObj(false, {
		searchFormId: 'quickOrderForm',
		resultWrapId: 'quickOrderBox', 
		basketBtnId: 'quickOrderSubmit',
		productSelector: '.product',
		loader: null
	}, options);
	
	this.init = ()=>{
		this.searchFormEl = document.getElementById(self.options.searchFormId);
		this.searchTextEl = this.searchFormEl.querySelector('input[name=quickAddSearch]');
		// this.searchSubmitEl = this.searchFormEl.querySelector('[type=submit]');
		this.resultWrap = document.getElementById(self.options.resultWrapId);
		
		self.showMsg('MSG_ZADNE_VYSLEDKY', 'info');
		
		EBContext.utils.element.setOverride(this.searchFormEl, 'onsubmit', ()=>{
			EBContext.ajaxNav.navigationTrigger(self.searchFormEl.action, null, null, {
				navigation:false, 
				reload: '*BODY,quickOrderBox:' + self.options.resultWrapId, 
				loader: self.options.loader, 
				callback: self.searchCallback, 
				requestParams: EBContext.utils.serializeForm(self.searchFormEl, true)
			});
			return false;
		}, false);
		
		this.searchTextEl.addEventListener('keydown', event=>{
			if(event.code==='Escape') self.clearSearch();
		});
		this.searchTextEl.focus();
	};
	this.bindKeys = ()=>{
		[...self.resultWrap.querySelectorAll('.basketForm input,.basketForm button,.basketForm select')].forEach(el=>{
			el.addEventListener('keydown', event=>{
				if(['Space','Enter'].includes(event.code)){
					event.preventDefault();
					event.stopPropagation();
				}
				let selEl = el.closest(self.options.productSelector).querySelector('[name=selected]');
				switch(event.code) {
					case 'Space':
						selEl.checked = !selEl.checked;
						EBContext.session.basket.select(selEl);
						break;
					case 'Enter':
						self.basketAdd();
						break;
					case 'Escape':
						self.clearSearch();
						break;
				}
			});
		});
		document.getElementById(self.options.basketBtnId).addEventListener('click', self.basketAdd);
	};
	this.showMsg = (msg, type)=>{
		let msgEl = EBContext.utils.template('<div class="col-12 tile p-2 bg-light text-center"><div class="alert alert-<!--$type--> mb-0"><!--$msg--></div></div>', null, {
			msg: EBContext.resource(msg),
			type: type
		})[0];
		self.resultWrap.replaceChildren();
		self.resultWrap.appendChild(msgEl);
	};
	this.clearSearch = ()=>{
		while(self.resultWrap.firstChild) self.resultWrap.removeChild(self.resultWrap.firstChild);
		self.showMsg('MSG_ZADNE_VYSLEDKY', 'info');
		self.searchTextEl.value = '';
		self.searchTextEl.focus();
	};
	this.selectFirstProduct = ()=>{
		let firstProduct = self.resultWrap.querySelector('.product');
		let firstProductCB = firstProduct.querySelector('[name=selected]:not([disabled])');
		if(firstProductCB){
			firstProductCB.checked = true;
			setTimeout(()=>firstProduct.querySelector('[name=amount]').focus(), 1);
		}
	};
	this.searchCallback = response=>{
		if(self.resultWrap.querySelector('.product')){
			self.bindKeys();
		} else {
			self.showMsg('MSG_ZADNE_VYSLEDKY', 'info');
		}
	};
	this.basketAdd = ()=>{
		EBContext.session.basket.form(self.resultWrap, {separate: true});
	};
	this.init();
	return this;	
};